import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-377d37c0")

_pushScopeId("data-v-377d37c0")
const _hoisted_1 = { class: "row list-search-area card-p" }
const _hoisted_2 = { class: "row mb-5" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 col-md-6 col-xl-3 mb-4"
}
const _hoisted_4 = {
  key: 1,
  class: "col-12 col-md-6 col-xl-3 mb-4"
}
const _hoisted_5 = {
  key: 2,
  class: "col-md-3 mb-4 mb-md-0"
}
const _hoisted_6 = {
  key: 3,
  class: "col-md-6 mb-4 mb-md-0 mb-4 mb-md-0"
}
const _hoisted_7 = {
  key: 4,
  class: "col-md-3 mb-4 mb-md-0 mb-4 mb-md-0"
}
const _hoisted_8 = {
  key: 5,
  class: "col-md-3 mb-4 mb-md-0"
}
const _hoisted_9 = {
  key: 6,
  class: "col-md-3 mb-4 mb-md-0 mb-4 mb-md-0"
}
const _hoisted_10 = {
  key: 7,
  class: "col-md-3 mb-4 mb-md-0"
}
const _hoisted_11 = {
  key: 8,
  class: "col-md-3 mb-4 mb-md-0"
}
const _hoisted_12 = {
  key: 9,
  class: "col-12 col-md-6 col-xl-3 mb-4"
}
const _hoisted_13 = {
  key: 10,
  class: "col-md-6"
}
const _hoisted_14 = {
  key: 11,
  class: "col-md-3"
}
const _hoisted_15 = {
  key: 12,
  class: "col-12 col-md-6 col-xl-3 mb-4"
}
const _hoisted_16 = { class: "row align-items-center" }
const _hoisted_17 = {
  key: 0,
  class: "col-md-12 col-lg-12 col-xxl-8 mb-4 mb-md-0 mb-4 mb-md-0"
}
const _hoisted_18 = {
  key: 1,
  class: "col-md-12 col-lg-12 col-xxl-8 mb-4 mb-md-0"
}
const _hoisted_19 = {
  key: 2,
  class: "col-md-2"
}
const _hoisted_20 = {
  key: 3,
  class: "col-12 col-md-6 col-xl-4 mb-4 mb-xl-0"
}
const _hoisted_21 = {
  key: 4,
  class: "col-12 col-md-6 col-xl-4 mb-4 mb-xl-0"
}
const _hoisted_22 = {
  key: 5,
  class: "col-md-3"
}
const _hoisted_23 = {
  key: 6,
  class: "col-md-3"
}
const _hoisted_24 = { class: "col-12 col-xxl-4 mt-0 mt-xxl-0 search-actions" }
const _hoisted_25 = { class: "indicator-label" }
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "bi bi-arrow-repeat fs-3 pe-0" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("i", { class: "bi bi-file-earmark-arrow-up-fill fs-3 pe-0" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_ExportModal = _resolveComponent("ExportModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.filterOption?.order_id == true)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode(_component_Input, {
                name: "order_id",
                target: "order_id",
                order_id: _ctx.filterData.order_id,
                "onUpdate:order_id": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterData.order_id = $event)),
                placeholder: _ctx.$t('message.ENTER_ID'),
                value: _ctx.filterData.order_id,
                onKeyup: _withKeys(_ctx.searchHandler, ["enter"])
              }, null, 8, ["order_id", "placeholder", "value", "onKeyup"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.name_order == true)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_Input, {
                name: "name",
                target: "name",
                "onUpdate:name": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterData.name = $event)),
                placeholder: _ctx.$t('message.ENTER_NAME'),
                value: _ctx.filterData.name,
                onKeyup: _withKeys(_ctx.searchHandler, ["enter"])
              }, null, 8, ["name", "placeholder", "value", "onKeyup"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.economic_number == true)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_Input, {
                name: "economic_number",
                type: "text",
                target: "economic_number",
                economic_number: _ctx.filterData.economic_number,
                "onUpdate:economic_number": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterData.economic_number = $event)),
                placeholder: _ctx.$t('message.ENTER_ECONOMIC_NUMBER'),
                value: _ctx.filterData.economic_number,
                onKeyup: _withKeys(_ctx.searchHandler, ["enter"])
              }, null, 8, ["economic_number", "placeholder", "value", "onKeyup"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.customer_report_email == true)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode(_component_Input, {
                name: "email",
                target: "email",
                email: _ctx.filterData.email,
                "onUpdate:email": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filterData.email = $event)),
                placeholder: _ctx.$t('message.ENTER_EMAIL'),
                value: _ctx.filterData.email,
                onKeyup: _withKeys(_ctx.searchHandler, ["enter"])
              }, null, 8, ["email", "placeholder", "value", "onKeyup"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.email == true)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode(_component_Input, {
                name: "email",
                target: "email",
                email: _ctx.filterData.email,
                "onUpdate:email": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filterData.email = $event)),
                placeholder: _ctx.$t('message.ENTER_EMAIL'),
                value: _ctx.filterData.email,
                onKeyup: _withKeys(_ctx.searchHandler, ["enter"])
              }, null, 8, ["email", "placeholder", "value", "onKeyup"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.customer_group == true)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode(_component_Select, {
                name: "customer_group",
                target: "customer_group",
                customer_group: _ctx.filterData.customer_group,
                "onUpdate:customer_group": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterData.customer_group = $event)),
                selectData: _ctx.customer_group,
                filterable: true,
                clearable: true,
                placeholder: _ctx.$t('message.SELECT_CUSTOMER_GROUP'),
                value: _ctx.filterData.customer_group
              }, null, 8, ["customer_group", "selectData", "placeholder", "value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.base_info == true)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode(_component_Select, {
                name: "basic_info",
                target: "basic_info",
                basic_info: _ctx.filterData.basic_info,
                "onUpdate:basic_info": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterData.basic_info = $event)),
                selectData: _ctx.translateFilters(_ctx.selectData),
                filterable: true,
                clearable: true,
                placeholder: _ctx.filterPlaceholder,
                value: _ctx.filterData.basic_info
              }, null, 8, ["basic_info", "selectData", "placeholder", "value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.sites == true)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode(_component_Select, {
                name: "site",
                target: "site",
                site: _ctx.filterData.site,
                "onUpdate:site": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filterData.site = $event)),
                selectData: _ctx.sites,
                filterable: true,
                clearable: true,
                placeholder: _ctx.$t('message.SELECT_SITE'),
                value: _ctx.filterData.site
              }, null, 8, ["site", "selectData", "placeholder", "value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.category == true)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode(_component_Select, {
                name: "category",
                target: "category",
                category: _ctx.filterData.category,
                "onUpdate:category": _cache[9] || (_cache[9] = ($event: any) => (_ctx.filterData.category = $event)),
                selectData: _ctx.categories,
                filterable: true,
                clearable: true,
                focus: true,
                onFocus: _ctx.loadCategory,
                placeholder: _ctx.$t('message.SELECT_CATEGORY'),
                value: _ctx.filterData.category
              }, null, 8, ["category", "selectData", "onFocus", "placeholder", "value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.order_status == true)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _createVNode(_component_Select, {
                name: "status",
                target: "status",
                status: _ctx.filterData.status,
                "onUpdate:status": _cache[10] || (_cache[10] = ($event: any) => (_ctx.filterData.status = $event)),
                selectData: _ctx.status,
                filterable: true,
                clearable: true,
                placeholder: _ctx.$t('message.SELECT_STATUS'),
                value: _ctx.filterData.status
              }, null, 8, ["status", "selectData", "placeholder", "value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.customer_report_status == true)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode(_component_Select, {
                name: "status",
                target: "status",
                status: _ctx.filterData.status,
                "onUpdate:status": _cache[11] || (_cache[11] = ($event: any) => (_ctx.filterData.status = $event)),
                selectData: _ctx.translateFilters(_ctx.status),
                filterable: true,
                clearable: true,
                placeholder: _ctx.$t('message.SELECT_STATUS'),
                value: _ctx.filterData.status
              }, null, 8, ["status", "selectData", "placeholder", "value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.status == true)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode(_component_Select, {
                name: "status",
                target: "status",
                status: _ctx.filterData.status,
                "onUpdate:status": _cache[12] || (_cache[12] = ($event: any) => (_ctx.filterData.status = $event)),
                selectData: _ctx.translateFilters(_ctx.status),
                filterable: true,
                clearable: true,
                placeholder: _ctx.$t('message.SELECT_STATUS'),
                value: _ctx.filterData.status
              }, null, 8, ["status", "selectData", "placeholder", "value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.economic_number_order == true)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode(_component_Input, {
                name: "economic_number",
                type: "number",
                target: "economic_number",
                economic_number: _ctx.filterData.economic_number,
                "onUpdate:economic_number": _cache[13] || (_cache[13] = ($event: any) => (_ctx.filterData.economic_number = $event)),
                placeholder: _ctx.$t('message.ENTER_ECONOMIC_NUMBER'),
                value: _ctx.filterData.economic_number,
                onKeyup: _withKeys(_ctx.searchHandler, ["enter"])
              }, null, 8, ["economic_number", "placeholder", "value", "onKeyup"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_16, [
        (_ctx.filterOption?.name == true)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode(_component_Input, {
                name: "name",
                target: "name",
                "onUpdate:name": _cache[14] || (_cache[14] = ($event: any) => (_ctx.filterData.name = $event)),
                placeholder: _ctx.$t('message.ENTER_NAME'),
                value: _ctx.filterData.name,
                onKeyup: _withKeys(_ctx.searchHandler, ["enter"])
              }, null, 8, ["name", "placeholder", "value", "onKeyup"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.base_info == true)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _createVNode(_component_Input, {
                name: "inputValue",
                target: "inputValue",
                inputValue: _ctx.inputValue,
                "onUpdate:inputValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.inputValue = $event)),
                placeholder: _ctx.translate(_ctx.inputPlaceholder),
                value: _ctx.inputValue,
                onKeyup: _withKeys(_ctx.searchHandler, ["enter"])
              }, null, 8, ["inputValue", "placeholder", "value", "onKeyup"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.job_status == true)
          ? (_openBlock(), _createBlock("div", _hoisted_19, [
              _createVNode(_component_Select, {
                name: "status",
                target: "status",
                status: _ctx.filterData.status,
                "onUpdate:status": _cache[16] || (_cache[16] = ($event: any) => (_ctx.filterData.status = $event)),
                selectData: _ctx.translateFilters(_ctx.status),
                filterable: true,
                clearable: true,
                placeholder: _ctx.$t('message.SELECT_STATUS'),
                value: _ctx.filterData.status
              }, null, 8, ["status", "selectData", "placeholder", "value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.date_filter)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.filterData.date_from,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.filterData.date_from = $event)),
                type: "date",
                placeholder: _ctx.$t('message.START_DATE'),
                format: "DD-MM-YYYY",
                "value-format": "DD-MM-YYYY"
              }, null, 8, ["modelValue", "placeholder"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.date_filter)
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.filterData.date_to,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.filterData.date_to = $event)),
                type: "date",
                placeholder: _ctx.$t('message.END_DATE'),
                format: "DD-MM-YYYY",
                "value-format": "DD-MM-YYYY"
              }, null, 8, ["modelValue", "placeholder"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.jobs_date_filter)
          ? (_openBlock(), _createBlock("div", _hoisted_22, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.filterData.date_from,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.filterData.date_from = $event)),
                type: "date",
                placeholder: _ctx.$t('message.START_DATE'),
                format: "DD-MM-YYYY",
                "value-format": "DD-MM-YYYY"
              }, null, 8, ["modelValue", "placeholder"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filterOption?.jobs_date_filter)
          ? (_openBlock(), _createBlock("div", _hoisted_23, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.filterData.date_to,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.filterData.date_to = $event)),
                type: "date",
                placeholder: _ctx.$t('message.END_DATE'),
                format: "DD-MM-YYYY",
                "value-format": "DD-MM-YYYY"
              }, null, 8, ["modelValue", "placeholder"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_24, [
          _createVNode("button", {
            type: "button",
            class: "btn btn-custom",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.searchHandler()))
          }, [
            _createVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('message.SEARCH')), 1)
          ]),
          _createVNode("button", {
            type: "button",
            class: "btn btn-custom ml-3",
            onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.reloadListing && _ctx.reloadListing(...args)))
          }, [
            _hoisted_26
          ]),
          _createVNode("button", {
            type: "button",
            class: "btn btn-custom ml-3",
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.exportHandler()))
          }, [
            _hoisted_27
          ])
        ])
      ])
    ]),
    _createVNode(_component_ExportModal, {
      onExportFile: _ctx.exportFile,
      ref: "exportComponent",
      dateFilter: _ctx.dateFilter
    }, null, 8, ["onExportFile", "dateFilter"])
  ], 64))
})